import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { memo, forwardRef, useState, useRef, useEffect, useCallback } from 'react';
import { ArrowUp } from 'react-feather';
import mergeRefs from 'react-merge-refs';
import smoothscroll from 'smoothscroll-polyfill';
import defaultStyles from './styles/BackToTop.module.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const BackToTop = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  visibleHeight = 400,
  target,
  onClick,
  dataTestId,
  theme,
  label = 'Back Top',
  icon = /*#__PURE__*/jsx(ArrowUp, {}),
  showLabel = true
}, ref) => {
  // @ts-ignore
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const [visible, setVisible] = useState(false);
  const backToTopRef = useRef(null);
  useEffect(() => {
    smoothscroll.polyfill();
    return () => {
      return null;
    };
  }, []);
  useEffect(() => {
    const listener = () => {
      window.scrollY > visibleHeight ? setVisible(true) : setVisible(false);
    };
    globalThis.addEventListener('scroll', listener);
    return () => {
      globalThis.removeEventListener('scroll', listener);
    };
  }, [target, visibleHeight, backToTopRef]);
  const scrollToTop = useCallback(() => {
    if (target) {
      document.getElementById(target).scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      document.documentElement.scroll({
        top: 0,
        behavior: 'smooth'
      });
    }
    onClick && onClick();
  }, [target, onClick]);
  return /*#__PURE__*/jsx("div", {
    "data-test-id": dataTestId,
    ref: mergeRefs([backToTopRef, ref]),
    className: clsx(styles.root, visible && styles.visible),
    children: /*#__PURE__*/jsxs("button", {
      onClick: scrollToTop,
      className: clsx(styles.button, showLabel && styles.with_lebel),
      type: "button",
      children: [icon && /*#__PURE__*/jsx("span", {
        className: styles.icon,
        children: icon
      }), showLabel && label]
    })
  });
}));
BackToTop.displayName = 'BackToTop';

export { BackToTop };
